export const specialCharacterRegex: RegExp = /^[^#%$&½?@æ~!|*"`]*$/